import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './BottomNav.css';

const HomeIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
       strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M3 10.5 12 3l9 7.5V21a1 1 0 0 1-1 1h-5v-7H9v7H4a1 1 0 0 1-1-1V10.5z"/>
  </svg>
);

const StarIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12 2 14.6 8.9 22 9.6l-5.5 4.9L18.2 22 12 18l-6.2 4 1.7-7.5L2 9.6l7.4-.7L12 2z"/>
  </svg>
);

const ChatIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12 2C6.48 2 2 6.03 2 11c0 2.41 1.06 4.6 2.79 6.19L4 22l4.86-1.74C10.04 20.74 11.01 21 12 21h.01c5.52 0 10-4.03 10-9s-4.48-10-10-10z"/>
  </svg>
);

const UsersIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
       strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/>
    <circle cx="9" cy="7" r="4"/>
    <path d="M22 21v-2a4 4 0 0 0-3-3.87"/>
    <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
  </svg>
);

const MoreIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
       strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <line x1="3" y1="6"  x2="21" y2="6"/>
    <line x1="3" y1="12" x2="21" y2="12"/>
    <line x1="3" y1="18" x2="21" y2="18"/>
  </svg>
);

// `external: true` skips React Router so the browser does a full navigation —
// required for backend-served pages like /chat (Express, not React).
const TABS = [
  { to: '/',          label: 'Home',      Icon: HomeIcon,  match: (p) => p === '/' },
  { to: '/reviews',   label: 'Reviews',   Icon: StarIcon,  match: (p) => p.startsWith('/reviews') },
  { to: '/chat',      label: 'Chat',      Icon: ChatIcon,  match: (p) => p.startsWith('/chat'),
    primary: true, external: true },
  { to: '/community', label: 'Community', Icon: UsersIcon, match: (p) => p.startsWith('/community') },
  { to: '/services',  label: 'More',      Icon: MoreIcon,  match: (p) => p.startsWith('/services')
                                                                     || p.startsWith('/about')
                                                                     || p.startsWith('/contact') },
];

const BottomNav = () => {
  const { pathname } = useLocation();
  const [pendingTo, setPendingTo] = useState(null);

  return (
    <nav className="bn" aria-label="Primary">
      <ul className="bn__list">
        {TABS.map(({ to, label, Icon, match, primary, external }) => {
          const active = match(pathname);
          const pending = pendingTo === to;
          const className =
            `bn__item${primary ? ' bn__item--primary' : ''}${active ? ' bn__item--active' : ''}${pending ? ' bn__item--pending' : ''}`;
          const inner = (
            <>
              <span className="bn__icon">{pending ? <Spinner /> : <Icon />}</span>
              <span className="bn__label">{pending ? 'Opening…' : label}</span>
            </>
          );
          return (
            <li key={to} className={className}>
              {external ? (
                <a
                  href={to}
                  className="bn__link"
                  aria-current={active ? 'page' : undefined}
                  onClick={() => setPendingTo(to)}
                >{inner}</a>
              ) : (
                <Link to={to} className="bn__link" aria-current={active ? 'page' : undefined}>{inner}</Link>
              )}
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

const Spinner = () => (
  <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
    <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" strokeWidth="2.5"
            strokeLinecap="round" strokeDasharray="14 36">
      <animateTransform attributeName="transform" type="rotate" from="0 12 12" to="360 12 12"
                        dur="0.8s" repeatCount="indefinite"/>
    </circle>
  </svg>
);

export default BottomNav;
